import { ChangeTariffAnalytics } from './ChangeTariff.analytics';
import { ConstructorAnalytics } from '.';

class ConstructorCurrentTariffAnalytics extends ConstructorAnalytics {
    changeTariff: ChangeTariffAnalytics

    constructor(category = 'constructor_authorized') {
        super();
        this.category = category;
        this.changeTariff = new ChangeTariffAnalytics(this.category);
    }

    clickedMoveToChangeTariff() {
        this.send('click_move_to_change_tariff');
    }
}

export const constructorCurrentTariffAnalytics = new ConstructorCurrentTariffAnalytics();


